import { ModalContext } from 'components/ChartAlert/Contexts/ModalContext';
import React, { useState } from 'react';

const ModalContextProvider = ({
    children,
}: {
    children: JSX.Element;
}): JSX.Element => {
    const [isDirty, setDirty] = useState(false);
    return (
        <ModalContext.Provider value={{ isDirty, setDirty }}>
            {children}
        </ModalContext.Provider>
    );
};

export default ModalContextProvider;
